import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface DeviceStoreState {
  deviceId?: string;
  pushToken?: string;
  setDeviceId: (deviceId: string) => void;
  setPushToken: (pushToken: string) => void;
}

export const useDeviceStore = create<DeviceStoreState>()(
  devtools((set) => ({
    setDeviceId: (deviceId) => set({ deviceId }),
    setPushToken: (pushToken) => set({ pushToken }),
  })),
);
